<template functional>
  <span>
    <a v-if="props.link && !props.descr.length" :href="props.link" target="_blank"><i class="el-icon-info info-icon"></i></a>
    <el-popover
      v-if="props.descr"
      trigger="hover"
      popper-class="service-popover">
      <span slot="reference"><i class="el-icon-info info-icon" ></i></span>
      <slot>
        <p v-html="props.descr"></p>
        <a v-if="props.link" :href="props.link" target="_blank">{{detailsLinkText}}</a>
      </slot>
    </el-popover>
  </span>
</template>

<script>
import { Button } from 'element-ui'
export default {
  name: 'ServiceInfo',
  components: {
    'el-button': Button
  },
  props: {
    link: {
      required: true,
      type: String
    },
    descr: {
      required: true,
      type: String
    }
  },
  computed: {
    detailsLinkText () {
      return this.$t('Details')
    }
  }
}
</script>
<style lang="scss">
  .info-icon {
    color: #9A9A9A;
    font-size: 14px;
    cursor: pointer;
    &:hover {
      color: #FB7954
    }
  }
  .service-popover {
    max-width: 500px;
    p {
      margin-bottom: 0;
    }
  }
</style>
